import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WorkspaceService } from '../services/workspace.service';
import { UserService } from '../services/user.service';
import { firstValueFrom } from 'rxjs';
import { CampaignService } from '../services/campaign.service';

export const workspaceGuard: CanActivateFn = async (route, state) => {
  const workspaceService = inject(WorkspaceService);
  if (workspaceService.workspaceId == route.params['workspace']) return !!workspaceService.workspaceId;
  return workspaceService.loadWorkspace(route.params['workspace']);
};

export const workspaceDefaultGuard: CanActivateFn = () => {
  const workspace = inject(WorkspaceService).currentWorkspace;
  const router = inject(Router);
  if (!workspace) return false;
  const destination = workspace._metadata?.coachOnly ? 'agent-tasks' : 'campaigns';
  return router.createUrlTree(['/w', workspace._id, destination]);
};

export const fullCampaignWorkspaceGuard: CanActivateFn = (route, state) => {
  const workspace = inject(WorkspaceService).currentWorkspace;
  if (!workspace) return false;
  if (!workspace._metadata?.coachOnly) return true;
  const destination = 'agent-tasks';
  const campaignTaskMatch = state.url.match(/^\/w\/[^/]+\/campaigns\/([^/?#]+)\/tasks(?:[?#]|$)/);
  const segments = ['/w', workspace._id, destination];
  if (campaignTaskMatch) segments.push(campaignTaskMatch[1]);
  return inject(Router).createUrlTree(segments);
};

export const workspaceAdminGuard: CanActivateFn = async (route, state) => {
  const workspaceService = inject(WorkspaceService);

  return workspaceService.hasAdminAccess();
};

export const campaignSupervisorGuard: CanActivateFn = async () => {
  const workspaceService = inject(WorkspaceService);
  const campaignService = inject(CampaignService);
  const userId = inject(UserService)._user?._id?.toString();
  const workspace = workspaceService.currentWorkspace;
  if (workspace?._metadata?.coachOnly || (userId && workspace?.members?.some(member => member.accepted
    && member.userId?.toString() === userId && member.roles.includes('coach')))) return true;
  if (await workspaceService.hasAdminAccess()) return true;
  const workspaceId = workspaceService.workspaceId;
  if (!workspaceId) return false;
  return campaignService.currentUserCanSuperviseWorkspace(workspaceId);
};
